// Libraries
import I18n from 'i18next'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import React, { Component } from 'react'
import { Layout, Menu, Icon, Avatar } from 'antd'
import { Link } from '@react-navigation/web'
import {
  filter,
  includes,
  map,
  isNil,
  has,
  forEach,
  defaultTo,
  get,
  toNumber,
  isEmpty,
  cloneDeep,
  some
} from 'lodash'

// Components
import Images from 'Images'

const { Sider } = Layout

class CustomSider extends Component {
  static propTypes = {
    theme: PropTypes.string,
    links: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    collapsible: PropTypes.bool
  }

  static defaultProps = {
    theme: 'light',
    collapsible: false,
    projects: [],
    links: {
      settings: {
        subMenu: 'Settings',
        icon: 'pages.settings.icon',
        title: 'pages.settings.title',
        screens: [
          // Sites
          {
            routeName: 'Sites',
            icon: 'pages.sites.icon',
            title: 'pages.sites.title',
            matchScreens: ['Sites', 'Site']
          },
          // Cuvettes
          {
            routeName: 'Basins',
            iconImg: Images.icons.basin,
            title: 'pages.basins.title',
            matchScreens: ['Basins', 'Basin']
          },
          // Bacs
          {
            routeName: 'Silos',
            iconImg: Images.icons.silo,
            title: 'pages.silos.title',
            matchScreens: ['Silos', 'Silo']
          },
          // RÃ©servoirs
          {
            routeName: 'Tanks',
            iconImg: Images.icons.tank,
            title: 'pages.tanks.title',
            matchScreens: ['Tanks', 'Tank']
          }
          // PAS DISPONIBLE EN MOCK POUR LE MOMENT
          // Utilisateurs
          // {
          //   routeName: 'Users',
          //   icon: 'pages.users.icon',
          //   title: 'pages.users.title',
          //   matchScreens: ['Users', 'User']
          // }
        ]
      },
      scenarios: {
        subMenu: 'Scenarios',
        icon: 'pages.scenarios.icon',
        title: 'pages.scenarios.title',
        screens: [
          // En cours
          {
            key: 'OngoingScenarios',
            routeName: 'Scenarios',
            params: { status: 'running' },
            icon: 'pages.scenarios.running.icon',
            title: 'pages.scenarios.running.title',
            matchScreens: ['Scenarios', 'Scenario'],
            matchParams: true
          },
          // TerminÃ©s
          {
            key: 'DoneScenarios',
            routeName: 'Scenarios',
            params: { status: 'done' },
            icon: 'pages.scenarios.done.icon',
            title: 'pages.scenarios.done.title',
            matchScreens: ['Scenarios', 'Scenario'],
            matchParams: true
          }
        ]
      }
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      collapsed: false
    }
  }

  /**
   * PrÃ©lÃ¨ve tous les Ã©crans dans une liste d'Ã©crans groupÃ©s
   */
  _flattenLinks = (links, subMenu) => {
    const flatten = []

    forEach(links, link => {
      if (has(link, 'subMenu')) {
        flatten.push(...this._flattenLinks(link.screens, link.subMenu))
      } else {
        if (!isNil(subMenu)) {
          link.subMenu = subMenu
        }

        flatten.push(link)
      }
    })

    return flatten
  }

  _handleCollapse = collapsed => {
    this.setState({ collapsed })
  }

  _renderMenuLink = ({
    title,
    routeName,
    image,
    params,
    subMenu,
    key = routeName || subMenu,
    icon,
    iconImg,
    screens,
    ...props
  }) => {
    return !isNil(screens) ? (
      <Menu.SubMenu
        key={key}
        title={
          <span>
            {!isNil(icon) ? (
              <Icon type={I18n.t(icon)} />
            ) : (
              !isNil(iconImg) && (
                <img
                  src={iconImg}
                  alt={defaultTo(I18n.t(title), '')}
                  title={defaultTo(I18n.t(title), '')}
                />
              )
            )}
            <span>{defaultTo(I18n.t(title), '')}</span>
          </span>
        }
      >
        {map(screens, this._renderMenuLink)}
      </Menu.SubMenu>
    ) : (
      <Menu.Item key={key}>
        <Link
          routeName={defaultTo(routeName, '')}
          params={defaultTo(params, {})}
        >
          {/* Image ou icon */}
          {!isNil(icon) ? (
            !isNil(image) ? (
              <Avatar shape='square' src={image} icon={I18n.t(icon)} />
            ) : (
              !isNil(icon) && <Icon type={I18n.t(icon)} />
            )
          ) : (
            !isNil(iconImg) && (
              <img
                src={iconImg}
                alt={defaultTo(I18n.t(title), '')}
                title={defaultTo(I18n.t(title), '')}
                className='ant-menu-item-icon-image'
              />
            )
          )}
          <span>{defaultTo(I18n.t(title), '')}</span>
        </Link>
      </Menu.Item>
    )
  }

  _renderMenu = () => {
    const { links } = this.props

    const currentScreen = {
      id: get(this.props, 'currentScreen.params.id'),
      params: get(this.props, 'currentScreen.params'),
      routeName: get(this.props, 'currentScreen.routeName')
    }

    const flattenLinks = this._flattenLinks(cloneDeep(links))

    // RÃ©cupÃ©ration des actifs en fonction du matchScreens
    const associatedScreens = filter(
      flattenLinks,
      ({ matchParams, matchScreens, matchIDs, params }) => {
        let isMatching

        // Passage en nombre pour Ãªtre sÃ»r que la comparaison soit bonne
        matchIDs = map(matchIDs, toNumber)

        // Page avec match ID prÃ©cis
        if (!isEmpty(matchIDs)) {
          isMatching =
            includes(matchScreens, get(currentScreen, 'routeName')) &&
            includes(matchIDs, toNumber(get(currentScreen, 'id')))
        } else if (matchParams) {
          // Les paramÃ¨tres actuels de l'Ã©cran doivent correspondrent Ã  ceux dÃ©clarÃ©s
          const isMatchingParams = some(
            params,
            (value, key) =>
              has(currentScreen.params, key) &&
              get(currentScreen.params, key) === value
          )

          isMatching =
            isMatchingParams &&
            includes(matchScreens, get(currentScreen, 'routeName'))
        } else {
          isMatching = includes(matchScreens, get(currentScreen, 'routeName'))
        }

        return isMatching
      }
    )

    const selectedKeys = map(associatedScreens, route =>
      defaultTo(get(route, 'key'), get(route, 'routeName'))
    )

    const openKeys = defaultTo(
      get(this.state, 'openKeys'),
      map(associatedScreens, 'subMenu')
    )

    return (
      <Menu
        defaultSelectedKeys={selectedKeys}
        selectedKeys={selectedKeys}
        onOpenChange={openKeys => this.setState({ openKeys })}
        defaultOpenKeys={openKeys}
        openKeys={openKeys}
        mode='inline'
      >
        {map(links, this._renderMenuLink)}
      </Menu>
    )
  }

  render() {
    const { collapsed } = this.state
    const { theme, collapsible } = this.props

    const logo = collapsed ? Images.icon : Images.logo_white

    return (
      <Sider
        theme={theme}
        collapsible={collapsible}
        collapsed={collapsed}
        onCollapse={this._handleCollapse}
      >
        {/* Logo de l'application */}
        <Link routeName='Sites'>
          <div className='ant-layout-sider-logo'>
            <img
              className='ant-layout-sider-logo-image'
              src={logo}
              alt='logo'
            />
          </div>
        </Link>

        {/* Menu */}
        {this._renderMenu()}
      </Sider>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(CustomSider, 'defaultProps', {})

  return {
    projects: defaultTo(get(state, 'project.items'), defaultProps.projects)
  }
}

const mapDispatchToProps = dispatch => ({})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomSider)
